import { combineReducers, PayloadAction } from '@reduxjs/toolkit';
import { authSlice } from './reducer/auth';
import { userSlice } from './reducer/user';
import { taxSlice } from './reducer/tax';
import { paymentSlice } from './reducer/payment';
import { userSetupSlice } from './reducer/user_setup';
import { stateSlice } from './reducer/state';
import { routerReducer } from './historyContext';
import { returnsSlice } from './reducer/returns';

const combinedReducer = combineReducers({
  auth: authSlice.reducer,
  user: userSlice.reducer,
  tax: taxSlice.reducer,
  payment: paymentSlice.reducer,
  userSetup: userSetupSlice.reducer,
  state: stateSlice.reducer,
  returns: returnsSlice.reducer,
  router: routerReducer
});

// Allows for a complete reset of Redux store upon user logout
// And prevents state leaking into another user session in same tab
export const rootReducer = (state: any, action: PayloadAction) => {
  if (action.type === authSlice.actions.logoutSuccess().type) {
    state = undefined;
  }
  return combinedReducer(state, action);
};
